import { createContext } from 'react'

import type { Role, SessionResponse, User } from '../lib/apiTypes'

export type SessionStatus = 'loading' | 'authenticated' | 'anonymous' | 'unavailable'

export type SessionContextValue = {
  status: SessionStatus
  user: User | null
  /** Error selain 401 saat membaca sesi, misalnya server tidak bisa dihubungi. */
  error: unknown
  role: Role | null
  canWrite: boolean
  totpEnrollmentRequired: boolean
  totpRequired: boolean
  /** Memuat ulang sesi dari GET /auth/me. */
  reload: () => void
  /**
   * Menerapkan sesi hasil login. Tanpa ini, state sesi tetap anonim setelah
   * masuk dan konsol langsung mengarahkan operator kembali ke halaman login.
   */
  signIn: (session: SessionResponse) => void
  /** Mengarahkan ke halaman login dengan halaman asal sebagai tujuan kembali. */
  redirectToLogin: () => void
  /** Mengakhiri sesi di server lalu membersihkan state konsol. */
  logout: () => Promise<void>
  /** Menandai sesi berakhir tanpa memanggil server, dipakai saat 401 dari endpoint lain. */
  markExpired: () => void
}

export const SessionContext = createContext<SessionContextValue | null>(null)
